import DetailOrder from "./detail-order";

export default DetailOrder;